import { signal } from "@/react/core/reactive.ts";

export const [useNativeInput, setUseNativeInput] = signal(false);